module.exports = __webpack_public_path__ + "img/Qatar.11b2f27d.svg";